import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import SearchIcon from '@mui/icons-material/Search';
import RestaurantMenuIcon from '@mui/icons-material/RestaurantMenu';
import MapIcon from '@mui/icons-material/Map';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import DeveloperModeIcon from '@mui/icons-material/DeveloperMode';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';

export const logo = "https://tube-us.com/tube_us.png";

export const categories = [
  { name: "Popular", icon: <TrendingUpIcon /> },
  { name: "Discover", icon: <SearchIcon /> },
  { name: "Cooking", icon: <RestaurantMenuIcon /> },
  { name: "Cars", icon: <LocalShippingIcon /> },
  { name: "Tech", icon: <DeveloperModeIcon /> },
  { name: "Travel", icon: <MapIcon /> },
  { name: "Finance", icon: <ShowChartIcon /> }
];

export const listeners = {
  videoSwitch: false,
  sumSwitch: false,
  playSwitch: false
};
